'use client';

import Footer from '@/components/Footer';
import Navigation from '@/components/Navigation';

export default function PrivacyClient() {
  return (
    <>
      <Navigation />
      <main className="min-h-screen pt-20">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <h5 className="text-xl font-semibold mb-4">Effective Date: 20 March 2024</h5>

            <p className="mb-6">
              Your privacy is important to us. This Privacy Policy outlines how Eshhar Real Estate (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) collects, uses, and protects your personal information when you access our property management and facility services. By using our services, you agree to the practices described in this Privacy Policy.
            </p>

            <h5 className="text-xl font-semibold mb-4">Information We Collect</h5>
            <p className="text-neutral-700 dark:text-gray-300 mb-4">
              We may collect and process the following types of personal information:
              <br />
              <br />
              <strong>Information you provide to us:</strong> This includes information you provide when you fill out forms on our site, including your name, email address, phone number, property details, and any other information you choose to provide.
              <br />
              <br />
              <strong>Information we collect about you:</strong> This includes technical information, including the Internet protocol (IP) address used to connect your computer to the Internet, your login information, browser type and version, time zone setting, browser plug-in types and versions, operating system and platform.
              <br />
              <br />
              <strong>Information we receive from other sources:</strong> This includes information we receive about you if you use any of the other websites we operate or the other services we provide. We work closely with third parties (including, for example, business partners, sub-contractors in technical, payment and delivery services, advertising networks, analytics providers, search information providers, credit reference agencies) and may receive information about you from them.
            </p>

            <h5 className="text-xl font-semibold mb-4">How We Use Your Information</h5>
            <p className="mb-4">We use the collected data to:</p>
            <ul className="list-disc pl-6 mb-6">
              <li>Provide property management and facility services.</li>
              <li>Manage your property requests, including maintenance, repairs, and service coordination.</li>
              <li>Communicate with you about your property needs, service updates, and relevant information.</li>
              <li>Analyze user behavior to improve our services and personalize your experience.</li>
              <li>Comply with legal and regulatory requirements for property management, payment processing, and data retention.</li>
            </ul>

            <h5 className="text-xl font-semibold mb-4">Contact Us</h5>
            <p className="mb-6">
              If you have any questions or concerns regarding this Privacy Policy or our data handling practices, please contact us at:
            </p>
            <p className="mb-6">
              <strong>Eshhar Real Estate</strong><br />
              <strong>Email:</strong> info@eshharrealestate.com<br />
              <strong>Phone:</strong> +974 44111144
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

